// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1wiDl","title":"Header_title__8Fmm3","side":"Header_side__2G_vV"};